// Evidence documents on NomOS (TZ-2, SEN-395). The stored-reports family, the Resource Advisor export/fill and the
// PDF bill-upload surface were retired with their pages (SEN-437, owner 2026-10-29); the NomOS routes stay
// (backend contract comes later, SEN-384). What remains is the initiative panel's evidence read.
//
// NomOS route (monad/api/v1/reports.py):
//   GET    /evidence-documents/{path}               -> {data: {path, title, content}}
import { nomosFetch, type NomosEnvelope } from '../client';
import type { AnyFn, NomosRegistry } from '../registry';

async function getEvidenceDoc(path: string): Promise<{ path: string; content: string }> {
  const encoded = path.split('/').map(encodeURIComponent).join('/');
  const r = await nomosFetch<NomosEnvelope<{ path: string; title: string; content: string }>>('GET', `/evidence-documents/${encoded}`);
  return r.data;
}

export const reportsImpl: NomosRegistry = {
  getEvidenceDoc: getEvidenceDoc as AnyFn,
};
